import type { TourDefinition } from '../types';

export const leadsTour: TourDefinition = {
  id: 'leads',
  title: 'Leads',
  steps: [
    {
      element: '[data-tour="leads-create-btn"]',
      popover: {
        title: 'Criar Lead',
        description:
          'Adicione novos leads manualmente ou via importação.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="leads-search"]',
      popover: {
        title: 'Busca de Leads',
        description:
          'Pesquise leads por nome, email ou telefone.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="leads-filters"]',
      popover: {
        title: 'Filtros',
        description:
          'Filtre leads por status, responsável, fonte e campos personalizados.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="leads-table"]',
      popover: {
        title: 'Tabela de Leads',
        description:
          'Visualize todos os seus leads. Clique nas colunas para ordenar. Arraste as bordas para redimensionar.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="leads-pagination"]',
      popover: {
        title: 'Paginação',
        description:
          'Navegue entre as páginas de resultados.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
